import { useTranslation } from 'react-i18next';
import { ControlledCheckbox } from 'shared-widget-components/src/components/ControlledInputs/ControlledCheckbox';
import { DataPolicyModal } from './DataPolicyModal';
import { useDataPolicy } from './hooks/useDataPolicy';
import { useFormContext } from 'shared-widget-components/src/providers/FormContextProvider';

interface CheckboxContainerProps {
  textColor: string;
  buttonColor: string;
  // adatkezelési szabályzat checkboxhoz tartozó hibaüzenet
  dataPolicyError: string;

  // felhasználó életkorát jelölő checkboxhoz tartozó hibaüzenet
  customerAgeError: string;
}

export const CheckboxContainer = ({ buttonColor, textColor, dataPolicyError, customerAgeError }: CheckboxContainerProps) => {
  const { register } = useFormContext();
  const { t } = useTranslation();
  const { isModalOpen, setIsModalOpen, dataPolicy, openDataPolicy, openWinegroupDataPolicy } = useDataPolicy();

  return (
    <div className='flex flex-col gap-[4px]'>
      <ControlledCheckbox
        inputKey='dataPolicy'
        register={register}
        label={t('subscribeWidget.checkbox1')}
        link={t('subscribeWidget.dataSecurity')}
        labelColor={textColor}
        linkColor={buttonColor}
        onClick={openDataPolicy}
      />
      {dataPolicyError && <p className='text-red-500'>{dataPolicyError}</p>}
      <ControlledCheckbox
        inputKey='winegroupDataPolicy'
        register={register}
        label={t('subscribeWidget.checkbox2')}
        link={t('subscribeWidget.wineGroupDataSecurity')}
        labelColor={textColor}
        linkColor={buttonColor}
        onClick={openWinegroupDataPolicy}
      />
      <ControlledCheckbox inputKey='customerAge' register={register} label={t('subscribeWidget.checkbox3')} labelColor={textColor} />
      {customerAgeError && <p className='text-red-500'>{customerAgeError}</p>}
      <DataPolicyModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} dataPolicy={dataPolicy} />
    </div>
  );
};
